import { render, staticRenderFns } from "./MiniviewAnswers.vue?vue&type=template&id=d1d64f0a"
import script from "./MiniviewAnswers.vue?vue&type=script&lang=js"
export * from "./MiniviewAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports